<template>
  <nav class="c-header__nav">
      <ul class="c-header__list">
          <li class="c-header__item"><router-link :to="{ name: 'experiments'}">{{ $t('nav.experiments')}}</router-link></li>
          <li class="c-header__item"><router-link :to="{ name: 'configuration'}">{{ $t('nav.configuration')}}</router-link></li>
      </ul>
  </nav>
</template>

<style lang="scss">
.router-link-exact-active {
      border-bottom: solid 2px #00BBCE;
      padding: 6px 0;
}
</style>

<script>
export default {
  name: 'NavDesktop',
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
}
</script>
